import { IssuesDumbbellChart } from "../../../../src/components/pulse/IssuesDumbbellChart";
import * as React from 'react';
export default {
  IssuesDumbbellChart,
  React
};